export const formatNumberWithDot = (num) => {
  if (num === null || num === undefined) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatCurrency = (num, isUnit = true) => {
  if (num === null || num === undefined) return null;
  return (
    new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num) + (isUnit ? "đ" : "")
  );
};
